import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Spinner from 'components/Spinner/desktop';

import { checkBonusPromoAllowed } from 'features/bonusProgram/data';

import GiftEditor from './GiftEditor';
import CurrentGiftsTable from './CurrentGiftsTable';
import './GiftManagement.scss';

const b = block('gift-management-desktop');

const GiftManagement = () => {
  const actionProcessing = useSelector(s => s.bonusProgram.actionProcessing);
  const authData = useSelector(s => s.auth);
  const locale = useSelector(s => s.locale.locale);

  if (!checkBonusPromoAllowed(authData)) return null;

  return (
    <article className={b()}>
      <Spinner isLoading={actionProcessing} foolViewport />
      {/* <h1 className={b('title')}>{locale.giftManagement}</h1> */}
      <div className={b('editor')}>
        <GiftEditor />
      </div>
      <CurrentGiftsTable />
    </article>
  );
};

export default GiftManagement;
